import WhmcsApi from './WhmcsApi';
import Swal from 'sweetalert2';

export const fetchEvo = async (products, token, invoiceId, facturacionAutomatica = false, nbps = false, promocode = "") => {
  try {
    if(products !== null){
      products =  JSON.stringify(products)
    }
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
    const response = await whmcsApi.request('addOrderEvo', {
      products,invoiceid: invoiceId, facturacionAutomatica, nbps, promocode
    }, 'POST', token);
    return response
  } catch (error) {
    Swal.fire({
      title: 'Error!',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
    console.error('Failed to fetch Evo payment:', error);
  }
};


export const fetchSPEI = async ({ products, token, facturacionAutomatica = false, nbps = false, promocode = '' }) => {
  try {
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
    const response = await whmcsApi.request(
      "addOrderSPEI",
      {
        products: JSON.stringify(products),
        facturacionAutomatica,
        nbps,
        promocode,
      },
      "POST",
      token
    );

    if (response.result === "error") {
      Swal.fire({
        title: "Error!",
        text: `Code: ${response.data.error_code}`,
        icon: "error",
        confirmButtonText: "OK",
      });
      return false;
    } else if (response.result === "success") {
      return response.data;
    }
  } catch (error) {
    Swal.fire({
      title: "Error!",
      text: error.message,
      icon: "error",
      confirmButtonText: "OK",
    });
    console.error("Failed to fetch Add Order:", error);
    return false;
  }
};

export const fetchPaypal = async (products, token, nbps, invoiceId, facturacionAutomatica = false, promocode = '' ) => {
  try {
    if(products !== null){
      products =  JSON.stringify(products)
    }
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
    const response = await whmcsApi.request('paypal', {
      products, nbps: nbps, invoiceId, facturacionAutomatica, promocode
    }, 'POST', token);
    return response
  } catch (error) {
    Swal.fire({
      title: 'Error!',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
    console.error('Failed to fetch PAypál payment:', error);
  }
};

export const fetchNbps= async (products, token, promocode = '') => {
  try {
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
    const response = await whmcsApi.request('nbxpoints', {
      products: JSON.stringify(products), promocode
    }, 'POST', token);
    return response
  } catch (error) {
    Swal.fire({
      title: 'Error!',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
    console.error('Failed to fetch Nbps payment:', error);
  }
};

export const fetchInvoice= async (invoiceId, token) => {
  try {
    const whmcsApi = new WhmcsApi(); // Create instance of WhmcsApi
    const response = await whmcsApi.request('invoiceData', {
      invoiceId,
    }, 'POST', token);
    return response
  } catch (error) {
    Swal.fire({
      title: 'Error!',
      text: error.message,
      icon: 'error',
      confirmButtonText: 'OK'
    });
    console.error('Failed to fetch Invoice:', error);
  }
};

